// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"f7c8dfb6","977":"24ba575d"}[chunkId] + ".chunk.js";
};